export default {
  showWelcomeModal: (state) => state.showWelcomeModal,
  showTutorialModal: (state) => state.showTutorialModal,
  getTutorial: (state) => state.tutorial,
  getSteps: (state) => state.steps,
  showStepsBanner: (state) => state.showStepsBanner,
  showFrequentQuestionsDrawer: (state) => state.showFrequentQuestionsDrawer,
  getNotifications: (state) => state.notifications,
  getViewTooltips: (state) => state.viewTooltips,
  getFrequentQuestions: (state) => state.frequentQuestions,
};
